import React from "react";
import { Menu } from "semantic-ui-react";

export default ({ activeitem, handleItemClick }) => (
  <Menu inverted vertical>
    <Menu.Item
      name="home"
      active={activeitem === "home"}
      onClick={handleItemClick}
    >
      Packages
    </Menu.Item>

    <Menu.Item
      name="history"
      active={activeitem === "history"}
      onClick={handleItemClick}
    >
      History
    </Menu.Item>
  </Menu>
);



// WEBPACK FOOTER //
// ./src/views/UserDash/SideNav.js